export default __webpack_public_path__ + "static/media/MaxEtMoi.9e81b3b1.png";